var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 26,
    viewBox: "0 0 82 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16505 7.1537H22.3908C22.3908 3.20683 19.1566 0.0493359 15.2257 0H0C0 3.94687 3.23422 7.1537 7.16505 7.1537Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.1329V26.0001H0.0497573C4.32888 26.0001 7.81189 22.4973 7.81189 18.2544V16.1823H9.10558C13.0862 16.1823 16.3204 12.9754 16.3204 9.02856H7.21481C3.23422 9.02856 0 12.1861 0 16.1329Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1092 11.0512V24.2733H36.074V11.9393H32.1432V24.2733H29.108V11.9393H27.3665V9.32449H29.108V7.59774C29.108 4.83493 30.7997 3.05884 33.4866 3.05884H38.9101V5.67364H33.4368C32.6905 5.67364 32.1432 6.36434 32.1432 7.5484V9.32449H37.3677C38.3131 9.32449 39.1092 10.1139 39.1092 11.0512Z",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1044 9.32437H43.0898V11.4952H43.1396C43.8859 10.2618 45.2791 8.92969 47.7172 8.92969C51.0012 8.92969 53.0413 11.2485 53.0413 14.8993V24.3225H50.0061V15.0967C50.0061 12.5312 48.6626 11.5445 46.9211 11.5445C44.8313 11.5445 43.1396 13.0246 43.1396 15.8367V24.2731H40.1044V9.32437Z",
    fill: "#ffffff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7378 16.7741C53.7378 12.1365 56.574 8.88037 61.3009 8.88037C65.6298 8.88037 68.0181 11.6432 68.3664 15.0474H65.2317C65.0825 13.1233 63.739 11.4952 61.3009 11.4952C58.5642 11.4952 56.8725 13.7153 56.8725 16.8234C56.8725 20.1289 58.813 22.2011 61.3009 22.2011C63.6892 22.2011 64.9829 20.425 65.2317 18.9449H68.3664C67.9684 22.0037 65.5303 24.8159 61.3009 24.8159C56.773 24.7172 53.7378 21.5597 53.7378 16.7741Z",
    fill: "#ffffff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0631 2.51611H72.0983V9.27513C72.0983 9.96583 72.0983 10.4592 72.0485 11.4952H72.0983C72.8447 10.2618 74.2379 8.92978 76.676 8.92978C79.96 8.92978 82 11.2486 82 14.8994V24.3226H78.9648V15.0968C78.9648 12.5313 77.6214 11.5446 75.8799 11.5446C73.79 11.5446 72.0983 13.0247 72.0983 15.8368V24.2732H69.0631V2.51611Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.ecaeadc7e86acc367158a9ecfbb2b2e7.svg";
export { ForwardRef as ReactComponent };